import { createSavedSearchWebhooksService } from "app/pages/sales-intelligence/modules/saved-search-webhooks/services/savedSearchWebhooksService";
import { createSignalsApiWebhookSubscriptionsService } from "app/pages/sales-intelligence/modules/signals-api-webhook/services/signalsApiWebhookSubscriptionsService";
import type { IFetchService } from "app/services/fetchService";

import { createCrmListsApiService } from "./services/crmListsService";
import { dynamicsService } from "./services/dynamicsService";
import { hubspotService } from "./services/hubspotService";
import { createIntegrationsService } from "./services/integrationsService";
import { salesforceService } from "./services/salesforceService";
import { createSignalsApiIntegrationService } from "./services/signalsApiIntegrationService";
import { suppressionListService } from "./services/suppressionListService";
import type { ManagementService } from "./type";

export const createManagementApiService = (fetchService: IFetchService): ManagementService => {
    return {
        ...suppressionListService(fetchService),
        ...salesforceService(fetchService),
        ...hubspotService(fetchService),
        ...dynamicsService(fetchService),
        ...createIntegrationsService(fetchService),
        ...createCrmListsApiService(fetchService),
        ...createSignalsApiIntegrationService(fetchService),
        ...createSignalsApiWebhookSubscriptionsService(fetchService),
        ...createSavedSearchWebhooksService(fetchService),
    };
};
